import { CeresProjectTypesConfig } from './interfaces/ceres-project-types-config.interface';

// Add new ProjectType in Database Table "project_type"
// Add new config for projecttype here
// Reference User is an employee Id whcih is used for project lead in guest user scenario

const PROJECTTYPES: CeresProjectTypesConfig[] = [
    {
        name: 'Basic',
        config: {
            'new-project.master-data.mpNumber': true,
            'new-project.master-data.title': true,
            'new-project.master-data.description': true,
            'new-project.master-data.comment': true,
            'new-project.master-data.project-lead': true,
            'new-project.master-data.department': true,
            'new-project.master-data.customer': true,
            'new-project.master-data.customer-readOnly': true,
            'new-project.master-data.planned-start': true,
            'new-project.master-data.planned-end': true,
            'new-project.master-data.location': true,
            'new-project.master-data.status': true,
            'new-project.master-data.maturity': true,
            'new-project.master-data.project-space-title': true,
            'new-project.master-data.project-space-link': true,
            'new-project.accounting-info.customer-type': true,
            'new-project.accounting-info.customer-type-readOnly': true,
            'new-project.accounting-info.beneficial': true,
            'new-project.accounting-info.cost-center': true,
            'new-project.accounting-info.cost-center-readOnly': true,
            'new-project.accounting-info.internal-psp-element': true,
            'new-project.accounting-info.customer-psp-element': true,
            'new-project.accounting-info.country-code': true,
            'new-project.accounting-info.currency': true,
            'new-project.accounting-info.contract-type': true,
            'new-project.accounting-info.contract-type-readOnly': true,
            'new-project.accounting-info.accounting-cycle': true,
            'new-project.accounting-info.accounting-cycle-readOnly': true,
            'new-project.accounting-info.invest': true,
            'new-project.accounting-info.foreign-customer': true,
            'new-project.accounting-info.tech-approval': true,
            'new-project.accounting-info.commercial-approval': true,
            'new-project.accounting-info.project-group': true,
            'new-project.accounting-info.project-employees': true,
            'new-project.accounting-info.project-classification': true,
            'project.tags.single': true,
            'project.tags.category1': true,
            'project.tags.category2': true,
            'new-project.accounting-info.transactionalBudget': true,
            'new-project.accounting-info.zfBudget': true,
            'new-project.accounting-info.discountApplicable': true,
            'new-project.accounting-info.discountValue': true,
            'new-project.financials.show-templates': true,
            'new-project.financials.readOnly': true,
            'new-project.financials.calculation.cost-per-day': true,
            'new-project.financials.overview.project-lead': true,
            'new-project.financials.overview.planned-costs': true,
            'new-project.financials.overview.margin': true,
            'new-project.financials.overview.planned-price': true,
            'new-project.financials.overview.project-value': true,
            'project.financials.project-value': true,
            'project.financials.project-value-readonly': true,
            'project.financials.order-value': true,
            'project.financials.forecast-charging-volume': true,
            'project.financials.forecast-external-costs': true,
            'project.financials.accounted-value': true,
            'project.financials.proposal-billing': true,
            'project.financials.remaining-budget': true,
            'project.financials.proportional-linear-remaining-budget': true,
            'project.financials.tenant-honorary-planned-costs': true,
            'project.financials.tenant-honorary-planned-price': true,
            'project.financials.tenant-honorary-actual-costs': true,
            'project.financials.tenant-honorary-actual-price': true,
            'project.financials.planned-external-costs': true,
            'project.financials.planned-price-external': true,
            'project.financials.actual-external-costs': true,
            'project.financials.accrued-costs-external': true,
            'project.financials.POC-value': true,
            'project.financials.POC-profit': true,
            'project.financials.POC-delta-allocation': true,
            'project.financials.actual-profit': true,
            'project.financials.travel-costs': true,
            'project.commercials.multiple-business-partner': true,
            'projects.project-properties.copied-from': true
        },
        referenceEmployee: null
    },
    {
        name: 'Classic',
        config: {
            'new-project.master-data.mpNumber': true,
            'new-project.master-data.title': true,
            'new-project.master-data.description': true,
            'new-project.master-data.comment': true,
            'new-project.master-data.project-lead': true,
            'new-project.master-data.department': true,
            'new-project.master-data.customer': true,
            'new-project.master-data.customer-readOnly': true,
            'new-project.master-data.planned-start': true,
            'new-project.master-data.planned-end': true,
            'new-project.master-data.location': true,
            'new-project.master-data.status': true,
            'new-project.master-data.maturity': true,
            'new-project.master-data.project-space-title': true,
            'new-project.master-data.project-space-link': true,
            'new-project.accounting-info.customer-type': true,
            'new-project.accounting-info.customer-type-readOnly': true,
            'new-project.accounting-info.beneficial': true,
            'new-project.accounting-info.cost-center': true,
            'new-project.accounting-info.cost-center-readOnly': true,
            'new-project.accounting-info.internal-psp-element': true,
            'new-project.accounting-info.customer-psp-element': true,
            'new-project.accounting-info.country-code': true,
            'new-project.accounting-info.currency': true,
            'new-project.accounting-info.contract-type': true,
            'new-project.accounting-info.contract-type-readOnly': true,
            'new-project.accounting-info.accounting-cycle': true,
            'new-project.accounting-info.accounting-cycle-readOnly': true,
            'new-project.accounting-info.invest': true,
            'new-project.accounting-info.foreign-customer': true,
            'new-project.accounting-info.tech-approval': true,
            'new-project.accounting-info.commercial-approval': true,
            'new-project.accounting-info.project-group': true,
            'new-project.accounting-info.project-employees': true,
            'new-project.accounting-info.project-classification': true,
            'project.tags.single': true,
            'project.tags.category1': true,
            'project.tags.category2': true,
            'new-project.accounting-info.transactionalBudget': true,
            'new-project.accounting-info.zfBudget': true,
            'new-project.accounting-info.discountApplicable': true,
            'new-project.accounting-info.discountValue': true,
            'new-project.financials.show-templates': true,
            'new-project.financials.readOnly': true,
            'new-project.financials.calculation.cost-per-day': true,
            'new-project.financials.overview.project-lead': true,
            'new-project.financials.overview.planned-costs': true,
            'new-project.financials.overview.margin': true,
            'new-project.financials.overview.planned-price': true,
            'new-project.financials.overview.project-value': true,
            'project.financials.project-value': true,
            'project.financials.project-value-readonly': true,
            'project.financials.order-value': true,
            'project.financials.forecast-charging-volume': true,
            'project.financials.forecast-external-costs': true,
            'project.financials.accounted-value': true,
            'project.financials.proposal-billing': true,
            'project.financials.remaining-budget': true,
            'project.financials.proportional-linear-remaining-budget': true,
            'project.financials.tenant-honorary-planned-costs': true,
            'project.financials.tenant-honorary-planned-price': true,
            'project.financials.tenant-honorary-actual-costs': true,
            'project.financials.tenant-honorary-actual-price': true,
            'project.financials.planned-external-costs': true,
            'project.financials.planned-price-external': true,
            'project.financials.actual-external-costs': true,
            'project.financials.accrued-costs-external': true,
            'project.financials.POC-value': true,
            'project.financials.POC-profit': true,
            'project.financials.POC-delta-allocation': true,
            'project.financials.actual-profit': true,
            'project.financials.travel-costs': true,
            'project.commercials.multiple-business-partner': true,
            'projects.project-properties.copied-from': true
        },
        referenceEmployee: null
    },
    {
        name: 'Proposal',
        config: {
            'new-project.master-data.mpNumber': true,
            'new-project.master-data.title': true,
            'new-project.master-data.description': true,
            'new-project.master-data.comment': true,
            'new-project.master-data.project-lead': true,
            'new-project.master-data.department': true,
            'new-project.master-data.customer': true,
            'new-project.master-data.customer-readOnly': true,
            'new-project.master-data.planned-start': true,
            'new-project.master-data.planned-end': true,
            'new-project.master-data.location': true,
            'new-project.master-data.status': true,
            'new-project.master-data.maturity': true,
            'new-project.master-data.project-space-title': true,
            'new-project.master-data.project-space-link': true,
            'new-project.accounting-info.customer-type': true,
            'new-project.accounting-info.customer-type-readOnly': true,
            'new-project.accounting-info.beneficial': true,
            'new-project.accounting-info.cost-center': true,
            'new-project.accounting-info.cost-center-readOnly': true,
            'new-project.accounting-info.internal-psp-element': true,
            'new-project.accounting-info.customer-psp-element': true,
            'new-project.accounting-info.country-code': true,
            'new-project.accounting-info.currency': true,
            'new-project.accounting-info.contract-type': true,
            'new-project.accounting-info.contract-type-readOnly': true,
            'new-project.accounting-info.accounting-cycle': true,
            'new-project.accounting-info.accounting-cycle-readOnly': true,
            'new-project.accounting-info.invest': true,
            'new-project.accounting-info.foreign-customer': true,
            'new-project.accounting-info.tech-approval': true,
            'new-project.accounting-info.commercial-approval': true,
            'new-project.accounting-info.project-group': true,
            'new-project.accounting-info.project-employees': true,
            'new-project.accounting-info.project-classification': true,
            'project.tags.single': true,
            'project.tags.category1': true,
            'project.tags.category2': true,
            'new-project.accounting-info.transactionalBudget': true,
            'new-project.accounting-info.zfBudget': true,
            'new-project.accounting-info.discountApplicable': true,
            'new-project.accounting-info.discountValue': true,
            'new-project.financials.show-templates': true,
            'new-project.financials.readOnly': true,
            'new-project.financials.calculation.cost-per-day': true,
            'new-project.financials.overview.project-lead': true,
            'new-project.financials.overview.planned-costs': true,
            'new-project.financials.overview.margin': true,
            'new-project.financials.overview.planned-price': true,
            'new-project.financials.overview.project-value': true,
            'project.financials.project-value': true,
            'project.financials.project-value-readonly': true,
            'project.financials.order-value': true,
            'project.financials.forecast-charging-volume': true,
            'project.financials.forecast-external-costs': true,
            'project.financials.accounted-value': true,
            'project.financials.proposal-billing': true,
            'project.financials.remaining-budget': true,
            'project.financials.proportional-linear-remaining-budget': true,
            'project.financials.tenant-honorary-planned-costs': true,
            'project.financials.tenant-honorary-planned-price': true,
            'project.financials.tenant-honorary-actual-costs': true,
            'project.financials.tenant-honorary-actual-price': true,
            'project.financials.planned-external-costs': true,
            'project.financials.planned-price-external': true,
            'project.financials.actual-external-costs': true,
            'project.financials.accrued-costs-external': true,
            'project.financials.POC-value': true,
            'project.financials.POC-profit': true,
            'project.financials.POC-delta-allocation': true,
            'project.financials.actual-profit': true,
            'project.financials.travel-costs': true,
            'project.commercials.multiple-business-partner': true,
            'projects.project-properties.copied-from': true
        },
        referenceEmployee: 134
    },
    {
        name: 'Preliminary',
        config: {
            'new-project.master-data.mpNumber': true,
            'new-project.master-data.title': true,
            'new-project.master-data.description': true,
            'new-project.master-data.comment': true,
            'new-project.master-data.project-lead': true,
            'new-project.master-data.department': true,
            'new-project.master-data.customer': true,
            'new-project.master-data.customer-readOnly': true,
            'new-project.master-data.planned-start': true,
            'new-project.master-data.planned-end': true,
            'new-project.master-data.location': true,
            'new-project.master-data.status': true,
            'new-project.master-data.maturity': true,
            'new-project.master-data.project-space-title': true,
            'new-project.master-data.project-space-link': true,
            'new-project.accounting-info.customer-type': true,
            'new-project.accounting-info.customer-type-readOnly': true,
            'new-project.accounting-info.beneficial': true,
            'new-project.accounting-info.cost-center': true,
            'new-project.accounting-info.cost-center-readOnly': true,
            'new-project.accounting-info.cost-center-blank': true,
            'new-project.accounting-info.cost-center-notAvailable': true,
            'new-project.accounting-info.country-code': true,
            'new-project.accounting-info.currency': true,
            'new-project.accounting-info.contract-type': true,
            'new-project.accounting-info.contract-type-readOnly': true,
            'new-project.accounting-info.accounting-cycle': true,
            'new-project.accounting-info.accounting-cycle-readOnly': true,
            'new-project.accounting-info.invest': true,
            'new-project.accounting-info.foreign-customer': true,
            'new-project.accounting-info.tech-approval': true,
            'new-project.accounting-info.commercial-approval': true,
            'new-project.accounting-info.project-group': true,
            'new-project.accounting-info.project-employees': true,
            'new-project.accounting-info.project-classification': true,
            'project.tags.single': true,
            'project.tags.category1': true,
            'project.tags.category2': true,
            'new-project.accounting-info.transactionalBudget': true,
            'new-project.accounting-info.zfBudget': true,
            'new-project.accounting-info.discountApplicable': true,
            'new-project.accounting-info.discountValue': true,
            'new-project.financials.show-templates': true,
            'new-project.financials.readOnly': true,
            'new-project.financials.calculation.cost-per-day': true,
            'new-project.financials.overview.project-lead': true,
            'new-project.financials.overview.planned-costs': true,
            'new-project.financials.overview.margin': true,
            'new-project.financials.overview.planned-price': true,
            'new-project.financials.overview.project-value': true,
            'project.financials.project-value': true,
            'project.financials.order-value': true,
            'project.financials.forecast-charging-volume': true,
            'project.financials.forecast-external-costs': true,
            'project.financials.accounted-value': true,
            'project.financials.proposal-billing': true,
            'project.financials.remaining-budget': true,
            'project.financials.proportional-linear-remaining-budget': true,
            'project.financials.tenant-honorary-planned-costs': true,
            'project.financials.tenant-honorary-planned-price': true,
            'project.financials.tenant-honorary-actual-costs': true,
            'project.financials.tenant-honorary-actual-price': true,
            'project.financials.planned-external-costs': true,
            'project.financials.planned-price-external': true,
            'project.financials.actual-external-costs': true,
            'project.financials.accrued-costs-external': true,
            'project.financials.POC-value': true,
            'project.financials.POC-profit': true,
            'project.financials.POC-delta-allocation': true,
            'project.financials.actual-profit': true,
            'project.financials.travel-costs': true,
            'project.commercials.multiple-business-partner': true,
            'projects.project-properties.copied-from': true
        },
        referenceEmployee: 134,
        referenceProjectPreliminary: 4194
    }
];

export default PROJECTTYPES;
